import React from 'react';
import { cn } from '../../utils/cn';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  message?: string;
}

export function LoadingSpinner({ size = 'md', className, message }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  const borderClasses = {
    sm: 'border-2',
    md: 'border-2',
    lg: 'border-4',
    xl: 'border-4'
  };

  return (
    <div className={cn("flex flex-col items-center justify-center animate-fadeIn", className)}>
      <div
        className={cn(
          "animate-spin rounded-full border-border",
          sizeClasses[size],
          borderClasses[size],
          "border-t-primary transition-colors duration-300"
        )}
        role="status"
        aria-label="Loading"
      >
        <span className="sr-only">Loading...</span>
      </div>
      {message && (
        <p className="mt-4 text-sm text-muted-foreground animate-fadeIn" style={{ animationDelay: '0.3s' }}>{message}</p>
      )}
    </div>
  );
}

// Full page loading spinner
export function PageLoadingSpinner({ message }: { message?: string }) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <LoadingSpinner size="lg" message={message} />
    </div>
  );
}

// Inline loading spinner
export function InlineLoadingSpinner({ size = 'sm' }: { size?: 'sm' | 'md' }) {
  return <LoadingSpinner size={size} className="inline-flex" />;
}